import {RECOVERY_REQUEST} from '../actionTypes'
import {reducerFactory} from '../../lib/asyncUtil'

export default reducerFactory(RECOVERY_REQUEST)
